<!--  class="wrapper wrapper-dark" -->
<div *ngIf="workWithUs && workWithUs.length>0">
  <!-- <div class="title-section title-dark mb-5">{{"Lavora con noi"|translate}}</div> -->

  <div class="box-wrapper">
    <div class="arrow-green white">
      
      {{"WORK_WITH_US_TITLE"|translate}}
    </div>
    <div class="arrow-right"></div>
    <div class="light-box list-service" *ngIf="workWithUs[0]">
      <span [innerHTML]="workWithUs[0].description"></span>
    </div>
  </div>
</div>